// removed by extract-text-webpack-plugin
module.exports = {"right-sider":"index__right-sider___1EbJ9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/RightSider/index.less
// module id = 1927
// module chunks = 3